// @flow

export function formatDate (date: string): any {
  let d
  if (date.indexOf('.') > -1) {
    const dmy = date.split('.')
    d = new Date(parseInt(dmy[2]), parseInt(dmy[1]) - 1, parseInt(dmy[0]))
  } else {
    d = new Date(date)
  }
  const year = new Intl.DateTimeFormat('de', { year: 'numeric' }).format(d)
  const month = new Intl.DateTimeFormat('de', { month: '2-digit' }).format(d)
  const day = new Intl.DateTimeFormat('de', { day: '2-digit' }).format(d)
  return `${day}.${month}.${year}`
}
